type TestIdGenerator = (id: string) => string;

export const makeTestId = (id: string, suffix: string, separator = '-'): string => {
  return `${id}${separator}${suffix}`;
};

export const makeFormControlId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'form-control');
};

export const makeInputId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'input');
};

export const makeHelperTextId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'helper-text');
};

export const makeLabelId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'label');
};

export const makeStartAdornmentId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'start-adornment');
};

export const makeEndAdornmentId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'end-adornment');
};

export const makeButtonId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'button');
};

export const makeCheckExpandableCheckboxGroupId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'expandable-checkbox-group');
};

export const makeCheckboxLabelId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'checkbox-label');
};

export const makeSwitchId: TestIdGenerator = (id: string) => {
  return makeTestId(id, 'switch');
};

export const makeCheckboxId: TestIdGenerator = (checkboxName: string) => {
  return makeTestId(checkboxName, 'checkbox');
};

export const makeCheckboxContainerId: TestIdGenerator = (checkboxName: string) => {
  return makeTestId(checkboxName, 'checkbox-container');
};
